import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const CRISP_READY = new InjectionToken<BehaviorSubject<boolean>>('CRISP_READY');

export const crispReady$ = new BehaviorSubject<boolean>(false);

// https://docs.crisp.chat/guides/chatbox-sdks/web-sdk/dollar-crisp/#use-crisp-before-it-is-ready
window.CRISP_READY_TRIGGER = () => {
  crispReady$.next(true);
};
